export interface RenderSavePayload {
  id: string;
  metadata: {
    question: string;
    subject: string;
    topic: string;
    language: string;
    timestamp: number;
    email?: string;
  };
  videoData: any;
}

const BACKEND_RENDER_URLS = [
  "/api/render/save",
  "https://ais-dev-nd7uiblul2inkbr6dymuih-14040789881.asia-southeast1.run.app/api/render/save",
  "https://ais-pre-nd7uiblul2inkbr6dymuih-14040789881.asia-southeast1.run.app/api/render/save"
];

export async function triggerRenderAndYouTubeUpload(payload: RenderSavePayload): Promise<void> {
  console.log(`[RenderClient] Enqueueing lesson "${payload.id}" for background rendering & YouTube upload...`);

  // Sequential dispatch: send to primary /api/render/save first.
  // Only try fallbacks if primary fails, and STOP as soon as one server accepts the job.
  // This guarantees exactly ONE backend executes the rendering and YouTube upload.
  (async () => {
    for (const url of BACKEND_RENDER_URLS) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 6000);
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (response.ok) {
          console.log(`[RenderClient] Successfully dispatched render job to ${url}. Single-pipeline dispatch complete.`);
          break;
        }
      } catch (err: any) {
        console.warn(`[RenderClient] Render job dispatch to ${url} attempt warning:`, err?.message || err);
      }
    }
  })();
}
